/* src/app/modules/labels/components/basic-round-border-label/basic-round-border-label.component.scss */
/*# sourceMappingURL=basic-round-border-label.component.css.map */
